import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Loader } from 'semantic-ui-react';

import hasRESTClient from '../../hocs/has-rest-client';

// Fetch just the count via the REST API (meta.page.total) — avoids pulling
// every story resource through the JSON:API client's caching graph.
class Stories extends Component {
  constructor(props) {
    super(props);
    this.state = { count: null, isLoading: true };
  }

  componentDidMount() {
    this.props.restClient.get(`/stories?filter[discussion]=${this.props.discussionId}&page[limit]=1`)
      .then(res => this.setState({ count: _.get(res, 'data.meta.page.total', 0), isLoading: false }))
      .catch(() => this.setState({ count: 0, isLoading: false }));
  }

  render() {
    const { count, isLoading } = this.state;
    if (isLoading) return <Loader active inline size="tiny" />;
    return <span>{count}</span>;
  }
}

Stories.propTypes = {
  discussionId: PropTypes.string.isRequired,
  restClient: PropTypes.shape({ get: PropTypes.func }).isRequired,
};

export default hasRESTClient(Stories);



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/stories.js
 **/